async function n(e=0){return new Promise(i=>{setTimeout(i,e);})}

export { n as a };
